function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import Form from "nood-comp/src/comp/form/Form";
import { _get, _post, _put, isHttpWithData } from "nood-comp/src/net/xhr";
import { __feedback } from "src/app/msg";
import { useNavigate } from "react-router-dom";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import AddOrEditButton from "nood-comp/src/comp/button/AddOrEditButton";
import FlexColumn from "nood-comp/src/comp/ui/containers/flex-boxes/FlexColumn";
import CenteredColumnWidth from "nood-comp/src/comp/ui/containers/CenteredColumnWidth";
import OptionPicker from "nood-comp/src/comp/form/dropdown/OptionPicker";
export default function VoucherCodeEditor(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    obj = _useState2[0],
    setObj = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var do_ = useURLParam('do');
  var id = useURLParam('id');
  var navigate = useNavigate();
  var is_edit = do_ === 'edit';
  function _submit(finalObj) {
    if (isValid && !isProcessing) {
      setIsProcessing(true);
      if (is_edit) {
        _put("/voucher-code/".concat(id), obj, function (res) {
          __feedback(res);
          setIsProcessing(false);
        });
      } else {
        _post("/voucher-code", obj, function (res) {
          var _res$http;
          __feedback(res);
          if ((res === null || res === void 0 || (_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200) {
            setObj({});
          }
          setIsProcessing(false);
        });
      }
    }
  }
  useEffect(function () {
    if (id) {
      _get("/voucher-code/".concat(id), function (res) {
        setObj(isHttpWithData(res));
      });
    }
  }, [is_edit, id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '20px'
    }
  }, /*#__PURE__*/React.createElement(Form, {
    obj: obj,
    __setter: setObj,
    __validSetter: setIsValid,
    __submit: function __submit(obj1, errors, submitCallback) {
      _submit(obj1);
    }
  }, /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 400
  }, /*#__PURE__*/React.createElement(FlexColumn, null, /*#__PURE__*/React.createElement(OptionPicker, {
    name: "status",
    label: "Status",
    icon: 'loader',
    options: [{
      code: 'Active',
      value: 'ACTIVE'
    }, {
      code: 'Redeemed',
      value: 'REDEEMED'
    }, {
      code: 'Invalid',
      value: 'INVALID'
    }]
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    obj: 'Voucher Code',
    edit: is_edit,
    processing: isProcessing,
    valid: isValid
  }))))));
}